import { api } from "./api";

const KEY = "eps_offline_queue";

export const getQueue = () => JSON.parse(localStorage.getItem(KEY) || "[]");
const saveQueue = (q) => {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("eps-queue"));
};

export function queueInspection(payload) {
  saveQueue([...getQueue(), { ...payload, offline: true }]);
}

export async function syncQueue() {
  if (!navigator.onLine) return 0;
  const remain = [];
  let done = 0;
  for (const p of getQueue()) {
    try {
      await api.post(p._endpoint || "/inspections", p, { headers: { "X-Site-Id": p.site_id } });
      done += 1;
    } catch (e) {
      if (!e.response || e.response.status >= 500 || e.response.status === 401) remain.push(p);
    }
  }
  saveQueue(remain);
  return done;
}

export async function compressImage(file, max = 1280) {
  const dataUrl = await new Promise((res) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.readAsDataURL(file);
  });
  if (!file.type.startsWith("image/")) return dataUrl;
  const img = await new Promise((res) => {
    const i = new Image();
    i.onload = () => res(i);
    i.src = dataUrl;
  });
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = img.width * scale;
  c.height = img.height * scale;
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  return c.toDataURL("image/jpeg", 0.72);
}
